import type { JSX } from 'react'
import type { ISkeletonProps } from '../Skeleton'

import { RowSkeleton } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton'
import { MainPageSkeletonSC } from 'blocks/Skeletons/Skeleton.styled'
import { CardsInRow } from 'containers/RowContainer/RowContainer.h'
import { BANNER_ASPECT_RATIO, BANNER_WIDTH, FIXED_INDENTS } from 'vars/index'
import { BannerSkeleton } from '../components/BannerSkeleton/BannerSkeleton'
import { Skeleton } from '../Skeleton'

export interface IMainPageSkeletonProps extends ISkeletonProps {
  bannerEnabled: boolean
  bannerAspectRatio?: BANNER_ASPECT_RATIO
  bannerWidth?: BANNER_WIDTH
  cardsCount: number
  cardsInRow: CardsInRow
  gap?: FIXED_INDENTS
}

export const MainPageSkeleton = ({
  bannerEnabled: _unused1,
  bannerAspectRatio = BANNER_ASPECT_RATIO.SKELETON_DEFAULT,
  bannerWidth = BANNER_WIDTH.SIZE_100,
  cardsCount: _unused2,
  cardsInRow = CardsInRow.Horizontal_3,
  gap = FIXED_INDENTS.INDENT_140,
  ...rest
}: IMainPageSkeletonProps): JSX.Element => {
  return (
    <Skeleton {...rest}>
      <MainPageSkeletonSC gap={gap}>
        <BannerSkeleton
          aspectRatio={bannerAspectRatio}
          bannerWidth={bannerWidth}
        />
        <RowSkeleton cardsInRow={cardsInRow} />
      </MainPageSkeletonSC>
    </Skeleton>
  )
}
